import { mapArray } from "@/shared";

import { mapClientFromServer } from "./mapClientFromServer";
export const mapClientsFromServer = mapArray(mapClientFromServer);
